import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { contactRelated } from "@mainaction";
import FourZeroFour from "../../common/pagenotfound";
import Loader from "@loader";
import LocaleStrings from "@language";

const ContactUnsubscribe = (props) => {
  let { session } = props;
  const [isInvalidURL, setIsInvalidURL] = useState(false);
  const [showThankyou, setshowThankyou] = useState(false);
  const [showLoader, setshowLoader] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Function to parse URL parameters
    const getUrlParams = (url) => {
      const params = {};
      const urlParams = new URLSearchParams(url.slice(url.indexOf("?") + 1));
      for (const [key, value] of urlParams) {
        params[key] = value;
      }
      return params;
    };
    // Get current URL
    const currentUrl = window.location.href;
    // Parse URL parameters
    const params = getUrlParams(currentUrl);

    // Extract id and case from parameters
    const { email, eventid } = params;

    if (email !== "" && eventid !== "") {
      let obj1 = {
        emailid: email,
        eventid: eventid,
      };

      props.contactRelated(session, obj1, (callback) => {
        if (callback.success === 1) {
          setshowThankyou(true);
          setshowLoader(false);
          setMessage(LocaleStrings.kContactUnsubscribeSuccess);
        } else {
          setshowLoader(false);
          setMessage(LocaleStrings.kContactUnsubscribeError);
        }
      });
    } else {
      setshowLoader(false);
      setIsInvalidURL(true);
      setMessage(LocaleStrings.kContactUnsubscribeError);
    }

    // Add dependencies as necessary
  }, []);

  return (
    <>
      {isInvalidURL ? (
        <>
          <FourZeroFour />
        </>
      ) : (
        <>
          {!showLoader ? (
            <>
              {showThankyou ? (
                <div className="mt-60 mx-20">
                  <div className="rounded-md border border-green-300 bg-green-50 p-4">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <CheckCircleIcon
                          className="h-6 w-6 text-green-400"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="ml-3">
                        <div className="text-md font-semibold text-green-700">
                          {message}
                        </div>
                      </div>
                      <div className="ml-auto pl-3">
                        <div className="-mx-1.5 -my-1.5"></div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            <Loader />
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ contactRelated }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContactUnsubscribe);
